export default "__VITE_ASSET__Dn_2v$EV__"